import { GenTableComponent } from "@app/gen-table/gen-table.component"
import { CcParamsGen } from "./../cc-params-gen/cc-params-gen"
import {
	Component,
	Input,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { AccountantScheduledReport } from "@app/definitions/types"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { OptionsList } from "@app/definitions/opts"
import { pluck } from "@app/services/api.service"
import { flipYesNo } from "@app/helpers"
import { COMMON_IMPORTS } from "../common-imports"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { FormsModule } from "@angular/forms"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-cc-params-accountant",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenAutocompleteComponent,
		GenInputComponent,
		FormsModule,
		GenButtonGroupComponent,
		BtnExtComponent,
		GenTableComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-params-accountant.component.html",
})
export class CcParamsAccountantComponent extends CcParamsGen {
	saveObjName: string = "accountant" //which part to save while updating
	isFormSubmittable: boolean = false
	contactNeedsEmail: boolean = false
	isSaving: boolean = false
	isSendingAll: boolean = false
	checkboxes: string[] = OptionsList.report_name_opts.map((it) => it.value)

	scheduledReport: AccountantScheduledReport = new AccountantScheduledReport()
	@ViewChild("personFuzzyInput") personFuzzyInput: GenAutocompleteComponent
	@ViewChild("scheduledReportsTbl") scheduledReportsTbl: GenTableComponent

	addNew() {
		this.scheduledReport.is_new_contact = flipYesNo(
			this.scheduledReport.is_new_contact
		)
		this.scheduledReport.contact_id = 0
		if (
			this.scheduledReport.is_new_contact == "yes" &&
			!this.scheduledReport.name
		) {
			this.scheduledReport.name = this.personFuzzyInput.searchStr
		}
		this.personFuzzyInput.searchStr = ""
		this.validateEntireForm()
	}
	async handleContactChange(obj: any = null) {
		this.contactNeedsEmail = false
		this.validateEntireForm()
		if (obj?.id) {
			const res: any = await this.apiService.post("contact_has_email", {
				id: obj.id,
			})
			this.contactNeedsEmail = !res.email
			this.validateEntireForm()
		}
	}
	flipCheck(fieldName: string) {
		this.scheduledReport[fieldName] = !this.scheduledReport[fieldName]
		this.validateEntireForm()
	}

	getValidationFields() {
		if (this.scheduledReport.is_new_contact === "yes") {
			return {
				name: { not_empty: true },
				email: { email: null, not_empty: true },
			}
		}
		return {
			contact_id: { is_legit_fuzzy_value: true },
			...(this.contactNeedsEmail && {
				email: { email: null, not_empty: true },
			}),
		}
	}
	validateEntireForm() {
		this.errors = {}
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.scheduledReport,
			this.errors,
			this.getValidationFields()
		)
		const hasAnyCheckbox = this.checkboxes.some(
			(it) => this.scheduledReport[it]
		)
		if (!hasAnyCheckbox) {
			this.errors.checkboxes = this.lang.getVal("no_report_was_chosen")
			this.isFormSubmittable = false
		}
	}

	async save() {
		if (this.isSaving) {
			return
		}
		this.isSaving = true
		const res: any = await this.apiService.post(
			"add_new_scheduled_reports",
			this.scheduledReport
		)
		this.isSaving = false
		if (res.success) {
			this.modalService.openToast("created_successfully")

			if (res.newContact) {
				this.store.addGenItemRow(
					"contacts",
					this.store.removeDecItem(res.newContact)
				)
			}
			this.scheduledReportsTbl.getItems()

			this.scheduledReport = new AccountantScheduledReport()
			this.contactNeedsEmail = false
			if (this.personFuzzyInput) {
				this.personFuzzyInput.emptySearchStr()
			}
		}
	}
	async send_all_reports() {
		this.isSendingAll = true
		await this.apiService.post("send_all_reports")
		this.isSendingAll = false
		this.modalService.openToast("resend_all_reports")
	}
}
